const SINGULARITY_URLS = {
  name: 'singularity'
}

export const appConfig = () => {
  return SINGULARITY_URLS
}
